import toast from 'react-hot-toast';
import type { PillTone } from '@/components/common/StatusPill';
import type { ProductCase } from '@/types/product';

/** For actions whose screens or API aren't built yet. */
export const comingSoon = (what: string) => toast(`${what} is coming soon.`);

// Buying protection from the dashboard (Figma B1–B7) is a later section.
export const addProtectionNotLive = () => comingSoon('Adding protection from your dashboard');

/** Badge for an order: In transit, Protected, Not protected, or plain Delivered once protection can't be added. */
export function orderStatus(order: ProductCase): { tone: PillTone; label: string } {
  if (order.state === 'on_the_way') return { tone: 'info', label: 'In transit' };
  if (order.state === 'protected') return { tone: 'success', label: 'Protected' };
  if (order.protectionClosedOn) return { tone: 'neutral', label: 'Delivered' };
  return { tone: 'warning', label: 'Not protected' };
}
